export const genericOptionsDefaults = {
    showPricesOnCalendar: false,
    hideQuickPayButtons: false,
    showLabels: true,
    fromDate: null,
    toDate: null,
    analyticsTitle: 'Booking Form',
    analyticsUrl: 'https://www.snowdome.co.uk/',
    analyticsPath: '/',
    chooseVisitorsTitle: 'Visitors',
    chooseVisitorsCopy: 'From price for adults and juniors. Under 2’s go free and must be pre-booked, subject to availability.',
    visitorInfoBands: [],
    showPriceOnBands: true,
    chooseSessionTitle: 'Santa’s Winter Wonderland',
    chooseSessionCopy: 'Approx. 1½ hours duration',
    submitButtonText: 'Proceed to basket',
    bookUrl: 'https://www.snowdome.co.uk/booking/availability',
    noSessionsText: 'No Sessions Found',
    onComplete: () => { },
    redirect: true,
    basketUrl: '/basket.html',
    showCalendarHeader: true,
    findingSessionsText: "Please wait, we're just finding a new date...",
    loadingSessionsMessage: 'Loading Sessions...',
    readingProductMessage: 'Loading...',
    loadingActivitiesMessage: 'Loading Activities...',
    loggedIn: false,
    termsHeading: '',
    termsSubheading: '',
    termsContent: '',
    allowOverlaps: false,
    voucherMessage: 'Gift Voucher? Redeem via basket',
    isMulti: false,
    isBuilder: false,
    successMessage: undefined,
    monthsShown: 1,
    calendarStartDay: 1,
    weekDayFormat: undefined,
    showAvailability: false,
    showSessionAvailability: false,
    priceBandId: undefined,
    debug: false,
    themeName: 'product',
    selectedDate: undefined,
    showTotalPrice: true,
    requiresSignature: false,
};
